import * as styles from './PromotionHeader.css';
import { PromotionSectionHeader } from '../PromotionSectionHeader';
import { AnimationElement, AnimationLayout } from '../../../common/Animation';
import { ServicesLayoutToggleContainer } from '../ServicesLayoutToggle';
import * as React from 'react';

export const PromotionHeader = ({ showServicesToggle }: { showServicesToggle: boolean }) => {
  return (
    <div className={styles.root}>
      <PromotionSectionHeader />

      {showServicesToggle && (
        <AnimationLayout>
          <AnimationElement layout="position">
            <ServicesLayoutToggleContainer />
          </AnimationElement>
        </AnimationLayout>
      )}
    </div>
  );
};
